import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';
import { PopupModalComponent } from '../../shared/popup-modal/popup-modal.component';
import { driver } from "driver.js";

@Component({
  selector: 'vex-favorite-workouts',
  templateUrl: './favorite-workouts.component.html',
  styleUrls: ['./favorite-workouts.component.scss']
})
export class FavoriteWorkoutsComponent implements OnInit {
  searchCtrl: string = '';
  favorites: any[] = [];
  filteredFavorites = [];
  environment = environment.baseURL;
  workoutNameLoader: boolean = true;
  workoutsPlaceholder = Array(5);
  favoriteLoading: any = {};
  workoutNameMap: any = {};

  constructor(public guiService: GuiService, public translate: TranslateService, private restService: RestService, private dialog: MatDialog, private router: Router) { }

  ngOnInit(){
    if(this.guiService.userLogged){
      this.getFavorites();
    }else{
      this.guiService.goTo('main/home');
    }
  }

  getFavorites(){
    if(this.guiService.userLogged.workoutInfo.favorites){
      const favorites = this.guiService.userLogged?.workoutInfo?.favorites ?? [];
      const uniqueWorkoutIds = [...new Set(favorites.map(fav => fav.workoutId))];
      this.getWorkoutNames(uniqueWorkoutIds);
    }
  }

  getWorkoutNames(ids) {
    const param = {
      userId: this.guiService.userLogged.user.id,
      workoutIds: ids
    }
    this.workoutNameLoader = true;
    this.restService.postService('node', '/workout-names', param).subscribe((ris) => {
      this.favorites = this.guiService.userLogged.workoutInfo.favorites;
      this.filteredFavorites = this.guiService.userLogged.workoutInfo.favorites;
      this.workoutNameLoader = false;
      ris.forEach(element => {
        this.workoutNameMap[element._id] = {
          i18nName: element.i18nName
        }
      });
      setTimeout(() => {
        localStorage.getItem('tourFavoriteWorkoutsShowed') ? null : this.startTour();
      }, 800);
    })
  }

  filterFavorites() {
    if (this.searchCtrl.length < 2) {
      this.filteredFavorites = this.favorites;
    } else {
      console.debug(this.favorites)
      this.filteredFavorites = this.favorites.filter(favorite =>
        this.workoutNameMap[favorite.workoutId].i18nName[this.translate.currentLang.toUpperCase()].toLowerCase().includes(this.searchCtrl.toLowerCase())
      );
    }
  }

  setFavoriteStatus(workoutObj){
    this.favoriteLoading = workoutObj;

    this.restService.postService('node', '/workout-favorite-status', {userId: this.guiService.userLogged.user.id, favorite: workoutObj}).subscribe((ris)=>{
      this.guiService.userLogged.workoutInfo.favorites = ris;
      this.filteredFavorites = ris;
      this.favorites = ris;
      this.favoriteLoading = {};
    })
  }

  openModalFavoriteStatus(workoutObj: any, workoutName: string): void {
  this.dialog.open(PopupModalComponent, {
    width: '400px',
    panelClass: 'custom-modal',
    disableClose: true,
    data: {
      title: workoutName,
      subTitle: this.translate.instant("DIARY.REMOVE-FAVORITE-MSG"),
      buttonTitle: this.translate.instant("HOME.MODAL-MARK.BTN-CONFIRM"),
      closeBtnTop: true,
      callbackBtn: 'remove'
    }
  }).afterClosed().subscribe(dataReturned => {
    if (dataReturned && dataReturned.callback === 'remove') {
      this.setFavoriteStatus(workoutObj);
    }
  });
}


  isMatch(a: any, b: any): boolean {
    return Object.keys(b).every(key => a[key] === b[key]);
  }

  getProgramName(programId) {
    return this.guiService.programs.find(x => x.id === programId).i18nName || null;
  }

  goToWorkout(workoutId) {
    this.router.navigate(['main/workout-detail-favorite'], {
      queryParams: { id: workoutId, colorClass: 1 }
    });
  }

  startTour(): void {
    localStorage.setItem('tourFavoriteWorkoutsShowed', 'true');

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.search-favorite', popover: { title: this.translate.instant('TUTORIALS.favorite-workouts.searchTrainingTitle'), description: this.translate.instant('TUTORIALS.favorite-workouts.searchTrainingDescription'), side: 'bottom' } },
        { element: '.favorite', popover: { title: this.translate.instant('TUTORIALS.favorite-workouts.startTrainingTitle'), description: this.translate.instant('TUTORIALS.favorite-workouts.startTrainingDescription'), side: 'bottom' } },
        { element: '.favorite-status', popover: { title: this.translate.instant('TUTORIALS.favorite-workouts.removeFavoriteTitle'), description: this.translate.instant('TUTORIALS.favorite-workouts.removeFavoriteDescription') } }
      ]
    });

    driverObj.drive();
  }
}

